module.exports = __webpack_public_path__ + "static/media/credible-c.580b2b06.png";